import { PopoverContent } from '@chakra-ui/react'

export default PopoverContent
